export default "__VITE_ASSET__CyxA8xyA__"